import { render } from "./BasePageHeading.vue?vue&type=template&id=61aaa49c&scoped=true&bindings={\"title\":\"props\",\"copy\":\"props\"}"
import script from "./BasePageHeading.vue?vue&type=script&lang=js"
export * from "./BasePageHeading.vue?vue&type=script&lang=js"

import "./BasePageHeading.vue?vue&type=style&index=0&id=61aaa49c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-61aaa49c"

export default script